import { useState } from "react";
import { Share2, Check, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";

export default function SharePhotoPicker({ car, onSaved }) {
  const [busy, setBusy] = useState(false);
  const photos = car.photos || [];
  const idx = Math.min(car.share_photo || 0, Math.max(photos.length - 1, 0));
  if (photos.length < 2) return null;
  const pick = async (i) => {
    setBusy(true);
    try { await api.patch(`/cars/${car.car_id}`, { share_photo: i }); onSaved?.(i); toast.success("Preview photo updated — shared links will show this one"); }
    catch (e) { toast.error(e?.response?.data?.detail || "Could not save"); } finally { setBusy(false); }
  };
  return (
    <div className="rounded-2xl border border-slate-800 bg-[#131722] p-4 space-y-2" data-testid="share-photo-picker">
      <p className="text-sm font-semibold inline-flex items-center gap-1.5"><Share2 className="w-4 h-4 text-cyan-400" />Preview photo for shared links</p>
      <p className="text-xs text-slate-500">This is the image WhatsApp, Facebook and X show when someone shares your listing.</p>
      <div className="flex gap-2 overflow-x-auto pb-1">
        {photos.map((p, i) => <button key={i} onClick={() => pick(i)} disabled={busy} data-testid={`share-photo-${i}`} aria-pressed={i === idx} className={`relative shrink-0 w-24 h-16 rounded-lg overflow-hidden border-2 ${i === idx ? "border-cyan-400" : "border-transparent hover:border-slate-600"}`}><img src={p} alt="" className="w-full h-full object-cover" />{i === idx && <span className="absolute top-1 right-1 w-5 h-5 rounded-full bg-cyan-400 text-slate-950 grid place-items-center">{busy ? <Loader2 className="w-3 h-3 animate-spin" /> : <Check className="w-3 h-3" />}</span>}</button>)}
      </div>
    </div>
  );
}
